import { useSession } from '../../../../../contexts/SessionContext'

import Button from '../../../../elements/direct-debit/Button'
import DDIcon from '../../../../icons/DDIcon'
import styles from './TerminalScreen.module.css'

// Spec §9 "Link expired" terminal screen. No auto-redirect per spec (unlike the legacy
// ExpiredScreen.js's 20s countdown) - "Back to Branch" is a manual action here.
const LinkExpiredScreen = () => {
  const { sessionData } = useSession()
  const redirectUrl = sessionData?.redirectUri
  const merchantName = sessionData?.merchantName || 'merchant'

  return (
    <div className={styles.body}>
      <span className={styles.iconCircle}>
        <DDIcon name='terminal-clock' />
      </span>
      <h1 className={styles.title}>This setup link has expired</h1>
      <p className={styles.message}>Ask {merchantName} for a new link to set up Direct Debit.</p>
      <div className={styles.actions}>
        <Button onClick={() => redirectUrl && window.location.replace(redirectUrl)} disabled={!redirectUrl}>
          Back to {merchantName}
        </Button>
      </div>
    </div>
  )
}

export default LinkExpiredScreen
